import React, { useEffect } from "react";
import "./profile.css";
import AdminSideBar from "../admin-page/AdminSideBar";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileApi } from "../../redux/apiCalls/profileApiCall";
import { useParams, useNavigate } from "react-router-dom";

function Profile() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile } = useSelector(state => state.profile);

  const { id } = useParams();

  useEffect(() => {
    dispatch(getUserProfileApi(id));
  }, [dispatch, id]);

  return (
    <main className="admin-page">
      <div className="admin-layout">
        <AdminSideBar />

        <section className="admin-main">
          <header className="admin-main-header">
            <div>
              <h2 className="admin-main-title">My Profile</h2>
              <p className="admin-main-subtitle">
                View your personal information
              </p>
            </div>
          </header>

          <div className="admin-main-body">
            <div className="profile-card">

              {/* Profile Header */}
              <div className="profile-header">
                <img
                  src={profile?.profilePicture?.url}
                  alt="Profile"
                  className="profile-avatar"
                />

                <div>
                  <h3 className="profile-name">{profile?.userName}</h3>
                  <span className="profile-role">
                    {profile?.isAdmin ? "admin" : "user"}
                  </span>
                </div>
              </div>

              {/* Profile Details */}
              <div className="profile-details">

                <div className="profile-row">
                  <span>Email</span>
                  <p>{profile?.email}</p>
                </div>

                <div className="profile-row">
                  <span>Department</span>
                  <p>{profile?.department}</p>
                </div>

                <div className="profile-row">
                  <span>Account Status</span>
                  <p>Activated</p>
                </div>

                {/* 2FA Section */}
                <div className="profile-row">
                  <span>Two-Factor Authentication</span>

                  <div className="profile-security">
                    <p>
                      {profile?.twoFactorEnabled ? "Enabled" : "Disabled"}
                    </p>

                    {!profile?.twoFactorEnabled && (
                      <button
                        className="btn-security"
                        onClick={() => navigate("/enable-2fa")}
                      >
                        Enable 2FA
                      </button>
                    )}
                  </div>
                </div>

              </div>

              {/* Actions */}
              <div className="profile-actions">
              </div>

            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Profile;
